import { FacebookLogo } from '@phosphor-icons/react';

export default FacebookLogo;
